import { ArrowRight, Check, FlaskConical, GraduationCap } from "lucide-react";
import { Link } from "react-router-dom";
import { EXAM_BY_ID } from "../data/exams";
import { lessonsFor, stagesFor } from "../data/localized";
import { useT } from "../i18n";
import { ProgressBar, useDocumentTitle } from "../components/ui";
import { useProgress } from "../lib/store";

export function LearnPage() {
  const t = useT();
  useDocumentTitle(t("Lộ trình học", "Learning path"));
  const p = useProgress();
  const LESSONS = lessonsFor(p.lang);
  const STAGES = stagesFor(p.lang);
  const done = LESSONS.filter((l) => p.lessons[l.id]).length;
  const next = LESSONS.find((l) => !p.lessons[l.id]);

  return (
    <>
      <h1>{t("Lộ trình học", "Learning path")}</h1>
      <p className="muted">
        {t(
          `${LESSONS.length} bài học ngắn, sắp xếp từ người mới tới kiến trúc sư doanh nghiệp. Mỗi bài: mục tiêu rõ ràng → kiến thức cốt lõi → câu kiểm tra nhanh → lab thực hành. Học tuần tự để có nền tảng vững nhất.`,
          `${LESSONS.length} short lessons, ordered from beginner to enterprise architect. Each one: clear objectives → core knowledge → quick check → hands-on lab. Go in order for the strongest foundation.`,
        )}
      </p>
      <div className="card row between">
        <div style={{ flex: 1, minWidth: 220 }}>
          <strong>{t(`${done}/${LESSONS.length} bài đã hoàn thành`, `${done}/${LESSONS.length} lessons completed`)}</strong>
          <div className="mt"><ProgressBar value={(done / LESSONS.length) * 100} label={t("Tiến độ lộ trình", "Path progress")} tone={done === LESSONS.length ? "ok" : undefined} /></div>
        </div>
        {next ? <Link className="btn primary" to={`/learn/${next.id}`}>{t("Học tiếp", "Continue")} <ArrowRight className="ico" size={16} aria-hidden="true" /></Link> : <span className="chip ok"><GraduationCap className="ico" size={16} aria-hidden="true" /> {t("Đã hoàn thành lộ trình", "Path completed")}</span>}
      </div>

      {STAGES.map((st) => {
        const lessons = LESSONS.filter((l) => l.stage === st.id);
        const stDone = lessons.filter((l) => p.lessons[l.id]).length;
        return (
          <section key={st.id}>
            <div className="stage-head">
              <span className="stage-num" style={{ background: EXAM_BY_ID[st.exam].accent }}>{st.id}</span>
              <div style={{ flex: 1 }}>
                <h2 className="mb-0">{st.title}</h2>
                <div className="small muted">{st.subtitle} · {stDone}/{lessons.length} {t("bài", "lessons")}</div>
              </div>
              <Link className="btn sm" to={`/exams/${st.exam}`}>{t("Đề", "Exam")} {EXAM_BY_ID[st.exam].code}</Link>
            </div>
            <div className="stack">
              {lessons.map((l) => (
                <Link key={l.id} to={`/learn/${l.id}`} className="card link lesson-item">
                  <span className={`check${p.lessons[l.id] ? " done" : ""}`} aria-label={p.lessons[l.id] ? t("Đã hoàn thành", "Completed") : t("Chưa học", "Not started")}>
                    {p.lessons[l.id] ? <Check size={16} strokeWidth={3} aria-hidden="true" /> : null}
                  </span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 600 }}>{l.title}</div>
                    <div className="small muted">{l.objectives.join(" · ")}</div>
                  </div>
                  <span className="small muted hide-sm">{l.minutes} {t("phút", "min")}</span>
                  {l.labIds.length > 0 && <span className="chip hide-sm"><FlaskConical className="ico" size={14} aria-hidden="true" /> {l.labIds.length}</span>}
                </Link>
              ))}
            </div>
          </section>
        );
      })}
    </>
  );
}
